import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.accounting.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-accounting-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.accounting.members/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccountingMembersComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public members: any[] = [];
    public showModal: boolean = false;
    public editMode: boolean = false;
    public form: any = { name: '', aliases: '', monthly_fee: 0 };
    public editId: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        let res = await wiz.call("list");
        if (res.code === 200) {
            this.members = res.data || [];
        }
        await this.service.render();
    }

    public openCreate() {
        this.editMode = false;
        this.form = { name: '', aliases: '', monthly_fee: 0 };
        this.showModal = true;
        this.service.render();
    }

    public openEdit(member: any) {
        this.editMode = true;
        this.editId = member.id;
        let aliases = '';
        try {
            let arr = JSON.parse(member.aliases || '[]');
            aliases = arr.join(', ');
        } catch { }
        this.form = {
            name: member.name,
            aliases: aliases,
            monthly_fee: member.monthly_fee || 0,
        };
        this.showModal = true;
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.service.render();
    }

    public async save() {
        let aliases = this.form.aliases.split(',').map((s: string) => s.trim()).filter((s: string) => s);
        let data: any = {
            name: this.form.name,
            aliases: JSON.stringify(aliases),
            monthly_fee: this.form.monthly_fee || 0,
        };
        let res;
        if (this.editMode) {
            data.id = this.editId;
            res = await wiz.call("update", data);
        } else {
            res = await wiz.call("create", data);
        }
        if (res.code === 200) {
            this.showModal = false;
            await this.load();
        } else {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '저장 실패' });
        }
        await this.service.render();
    }

    public async toggleActive(member: any) {
        let res = await wiz.call("toggle_active", { id: member.id });
        if (res.code === 200) {
            await this.load();
        }
    }

    public async remove(member: any) {
        let res = await this.service.modal.show({
            title: '멤버 삭제',
            message: `${member.name}을(를) 삭제하시겠습니까?`,
            action: '삭제',
            status: 'error'
        });
        if (!res) return;
        let delRes = await wiz.call("delete", { id: member.id });
        if (delRes.code === 200) {
            await this.load();
        }
    }

    public parseAliases(aliases: string): string[] {
        try {
            return JSON.parse(aliases || '[]');
        } catch {
            return [];
        }
    }
}

export default PageAccountingMembersComponent;